import * as zod from 'zod';

import { OnRobotVGP20Command } from '../../types';

export const ActuateVacuumArguments = zod.object({
  gripperCommand: OnRobotVGP20Command,
});

export type ActuateVacuumArguments = zod.infer<typeof ActuateVacuumArguments>;
